import React from "react"
import { Div, Input, Notification, Icon } from "atomize";
import { ReactComponent as CloseIcon } from './../../../Assets/Icons/close_white.svg';
import styled from "styled-components";
import {PrimaryButton, SecondaryButton} from "../../Atoms/Button";
import { connect } from "react-redux";
import ActivityCard from "./../ActivityCard";
import ActivitiesGroup from "./../ActivitiesGroup";
import {clearActivities} from "../../../redux/actions";
import {bindActionCreators} from "redux";
import createZipDownload from "../../../utils/createZipDownload";
import axios from 'axios';
import ProgressBar from '../ProgressBar';
import theme from "./../../../Theme/Theme";
import {captchaKey} from "../../../Constants/constants";
import ReCAPTCHA from "react-google-recaptcha";


const Container = styled(Div)`
  width: 600px;
  
  @media (max-width: 600px) {
    width: 100%;
  }
  
  box-shadow: rgba(8, 11, 14, 0.06) 0px 0px 1px 0px, rgba(8, 11, 14, 0.1) 0px 32px 40px -1px;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  
  .__react_component_tooltip.place-bottom.type-dark {
    margin-top: -.5rem;
  }
`;

const Wrapper = styled(Div)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  a {
    margin-top: 4px;
    margin-right: 30px;
    @media (max-width: 600px) {
      margin-right: 15px;
    }
  }
`;

const Title = styled.h2`
  color: #FFFFFF;	
  font-family: Inter;	
  font-size: 20px;	
  font-weight: bold;	
  line-height: 24px;
  padding: 3rem 30px;
  @media (max-width: 600px) {
    padding: 2rem 15px;
  }
`;

const Body = styled.div`
  margin: 30px;
  @media (max-width: 600px) {
      margin: 30px 15px;
  }
`;

const Subtitle = styled.h4`
  color: #0A1F44;	
  font-family: Inter;	
  font-size: 14px;	
  font-weight: bold;	
  line-height: 24px;
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ClearLink = styled.a`

`;

const Border = styled(Div)`
  // max-width: 500px;
  border: 1px solid #C9CED6;
  border-radius: 4px;
  padding: 2rem 1rem 1rem 1rem;
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  
  
  @media (max-width: 550px) {
    a, button {
      display: flex;
      width: 100%;
    }
  }
  
  @media (max-width: 550px) {
    .primary-wrapper {
      display: flex;
      width: 100%;
    }
  }
  
  a, button {
    margin: 0;
    margin-bottom: 1rem;
  }
  
  .share-container {
    width: 100%;
    input {
      margin-bottom: 1rem;
    }
    .primary-wrapper {
      margin-right: 1rem;
    }
  }
  .progress-bar {
    span {
      background: ${theme.colors.primary};
    }
    margin: 0 5px;
  }
`;

function CollectorContainer(props) {

  const [loading, setLoading] = React.useState(false);
  const [sharing, setSharing] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [valid, setValid] = React.useState(false);
  const [showNotification, setShowNotification] = React.useState(false);
  const [progress, setProgress] = React.useState(0);
  const [captcha, setCaptcha] = React.useState(false);
  const elem = React.useRef(null);

  const shareActivities = () => {
    let ids = [];
    props.collectorActivities.forEach( activity => {
      ids.push(activity.id)
    });
    const link = `https://courses.olin.edu/e4h/?activities=${ids.join()}`;
    // console.log(link);
    axios.get(`/share/link?email=${email}&link=${link}`)
      .then(function (response) {
        // handle success
        // console.log(response);
        setShowNotification(true)
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
        setSharing(false)
      });
  };

  React.useEffect( () => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [email]);

  return (
    <Container>
      <Notification
        bg="success700"
        isOpen={showNotification}
        onClose={() => setShowNotification(false)}
        prefix={
          <Icon
            name="Success"
            color="white"
            size="18px"
            m={{ r: "0.5rem" }}
          />
        }
      >
        Your collection has been shared
      </Notification>
      <Wrapper
        bg="#0A1F44"
      >
        <Title>
          { props.collectorActivities.length } Activities in your collection
        </Title>
        <a
          onClick={ () => props.close() }
        >
          <CloseIcon/>
        </a>
      </Wrapper>
      <Body>
        { props.collectorActivities.length > 0 &&
          <>
            <Top>
              <Subtitle>
                Your activities collection
              </Subtitle>
              <ClearLink
                onClick={ () => props.clearActivities() }
              >
                Clear all
              </ClearLink>
            </Top>
            <ActivitiesGroup
              activities={props.collectorActivities}
              dismissable={true}
              overflow={true}
            />
            <Border
              ref={elem}
            >
              {!sharing &&
                <>
                  <PrimaryButton
                    icon={loading ? 'Loading' : 'Download'}
                    type={'button'}
                    action={() => {
                      if (!loading) {
                        setLoading(true);
                        createZipDownload(props.collectorActivities, elem.current)
                          .then(res => {
                            if (res) {
                              setLoading(false)
                            }
                          })
                      }
                    }}
                    text={'Download your collection'}
                  />
                  <SecondaryButton
                    icon={'Mail'}
                    type={'button'}
                    action={() => setSharing(true)}
                    text={'Share your collection'}
                  />
                </>
              }
              {
                sharing &&
                <div className={'share-container'}>
                  <Input
                    placeholder="Email address"
                    h="2.5rem"
                    aria-label={'Email address'}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                  <div style={{height: "78px", marginBottom: "13px", width: "100%"}}>
                    <ReCAPTCHA
                      sitekey={captchaKey}
                      onChange={onChange => setCaptcha(true)}
                    />
                  </div>
                  <Div
                    d={'flex'}
                  >
                    <PrimaryButton
                      icon={'Mail'}
                      type={'button'}
                      action={() => shareActivities()}
                      text={'Share'}
                      disabled={!valid || !captcha}
                      tip={!valid ? "Invalid email address" : !captcha ? "Please check I'm not a robot" : null }
                    />
                    <SecondaryButton
                      icon={null}
                      type={'button'}
                      action={() => setSharing(false)}
                      text={'Cancel'}
                    />
                  </Div>
                </div>
              }
              {
                loading &&
                <ProgressBar
                  elem={elem}
                  activities={props.collectorActivities}
                />
              }
            </Border>
            {
              props.collectorActivities.map( a => {
                return (
                  <div
                    key={a.id}
                    style={{ margin: '1rem 0'}}
                  >
                    <ActivityCard
                      activity={a}
                    />
                  </div>
                )
              })
            }
          </>
        }
      </Body>
    </Container>
  )
}

const mapStateToProps = state => {
  if (state === undefined) return {};
  return {
    collectorActivities: state.collectorActivities.collectorActivities
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      clearActivities: clearActivities
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectorContainer);
